import React from "react";
import { getMessage } from "CONFIG/i18n";
import { Button} from "reactstrap";
import 'react-toastify/dist/ReactToastify.css';

import infoIcon from "ASSETS/Images/ic_info.svg"

let admitOrRejectUserInSession, messageKey, message, uniqueId;

class AdmitTostr extends React.Component {
  constructor(props) {
    admitOrRejectUserInSession = props.admitParticipant;
    messageKey = props.messageKey;
    message = props.message;
    uniqueId = props.uniqueId;
    super(props);
    this.state = {
      offline: false,
    }
  }

  render() {
    let currentUniqueId = uniqueId;
    return (
      <div>
        { messageKey != "ADMIT_USER" 
          ? 
          <div className="d-flex flex-row align-items-center">
            <img src={infoIcon} className="pr-2"/>
            <span className="toasterText">{message}</span>
          </div>
          :
          <div>
            <div className="d-flex flex-row align-items-center">
              <img src={infoIcon} className="pr-2"/>
              <span className="toasterText">{message}</span>
            </div>
            <div className="admitRejectSection admitRejectBtn">
              <Button
                onClick={() =>
                  admitOrRejectUserInSession(
                    true,
                    currentUniqueId,
                    false
                  )
                }
                className="buttons width-25 btnToastAdmit"
              >
                {getMessage("ADMIT")} 
              </Button>
              <Button
                onClick={() =>
                  admitOrRejectUserInSession(
                    false,
                    currentUniqueId,
                    false
                  )
                }
                className="buttons width-25 btnToastDismiss"
              >
                {getMessage("DISMISS")}
              </Button>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default AdmitTostr;
